
import { useState } from "react"
import addbanner from '../../../assets/images/core/CreateBanner.png'
import logo from '../../../assets/images/logos/Jobs_logo.png'

export const CareerState = () => {
  
    const [card, setCard]= useState ([])
    const [listLoader, setListLoader]= useState(false)
    const [lid, setLid] = useState()
    const [inftScroll, setInftScroll] = useState(true)
    const [lSearch, setLSearch]= useState('')
    const [menu, setMenu] = useState(false)
    const [anchorEl, setAnchorEl] = useState(false)
    const [career_id, setCareerId] = useState([])
    const [careerStatus, setCareerStatus] = useState([])
    const [btnLoader, setBtnLoader] = useState(true)
    const [saveStatModal, setSaveStatModal] = useState(false)
    const [stat, setStat] = useState(1)
    const [repostModal, setRepost]= useState(false)
    const [id, setId] = useState([])
    const [employmentId, setEmploymentId] = useState([])
    const [deploymentId, setDeploymentId] = useState([])
    const [openMenu, setOpenMenu] = useState(false)
    const [posterId, setPosterId] = useState([])
    const [hrcId, setHrcId] = useState([])
    const [hrcLoader, setHrcLoader] = useState (false)
    const [toolTP, setToolTP] = useState ({data:[],stat:false})
    const [referralModal, setReferralModal] = useState(false)
     const [refStat, setRefStat] = useState([])
     const [refStatModal, setRefStatModal] = useState(false)
    
    // const [active, setActive] = useState(false)

    //Create Update Career Post
    const [updateLoader, setUpdateLoader]= useState(false)
    const [deploymentSelected, setDeploymentSelected] = useState('')
    const [employmentSelected, setEmploymentSelected] = useState('')
    const [saveForm, setSaveForm] = useState(false)
    const [saveLoader, setSaveLoader] = useState(false)
    const [btnSaveLoader, setBtnSaveLoader] =useState(false)
    const [msg, setMsg] = useState(false)
    const [employmentStatus, setEmploymentStatus] = useState([       
            {id: 1, name: 'Full-Time'},
            {id: 2, name: 'Part-Time'},
            {id: 3, name: 'Temporary'},
            {id: 4, name: 'Casual'},
            {id: 5, name: 'Fixed-Term'},
            {id: 6, name: 'On-Call'},
            {id: 7, name: 'Seasonal'},
            {id: 8, name: 'Intern/Trainee'},
            {id: 9, name: 'Freelancer'},
            {id: 10, name: 'Contractor'},
            {id: 11, name: 'Consultant'},
            {id: 12, name: 'Project-Based'},        
        ])
    
        const [deploymentArrangement, setDeploymentArrangement] = useState([ 
            {id: 1, name: 'Work on site'},
            {id: 2, name: 'Work on site with Field work'},
            {id: 3, name: 'Work from home'},
            {id: 4, name: 'Hybrid terms'},
        ])
    
    //View

      const [pview, setPview]= useState ([])
      const [previewLoader, setPreviewLoader]= useState(false)

    //Personalization
    const [prnzlData, setPrnzlData] =useState([])
    const [prnlzationModal, setPrnlzationModal]=useState(false)
    const [cafguModal, setCafguModal] = useState(false)
    const [pznlTour, setPznlTour] = useState(false)
    const [welcome, setWelcome] = useState(false)
    const [createAccount, setCreateAccount] = useState(false)
    const [addTour, setAddTour] = useState(false)
    const [featureTour, setFeatureTour] = useState(false)
    const [startHere, setStartHere] = useState({show: true , modal: false, task: []},)
    const [walkthrough, setWalkthrough] = useState({createPost: false, readApplicant: false})
    const [readCareerPost, setReadCareerPost] = useState([])

    //IndexDb
    const [localDb, setLocalDb] = useState([])
    const [form, setForm] = useState ({ type: "create",
        submit: {modal: false, type: '', confirmed: false},
        inputs:{
            name: {value: '', stat: false, msg: '', toggled: false},
            position: {value: '', stat: false, msg: '', toggled: false},
            qualification: [{value: '', stat: false, msg: '', toggled: false}],
            description: [{value: '', stat: false, msg: '', toggled: false}],
            benefits: [{value: '', stat: false, msg: '', toggled: false}],
            banner: {value: null, object: addbanner, name: '', type: 'default', size: 0, updated: false, stat: false, msg: {value: '', stat: false, msg: ''}},
            logo: {value: null, object: logo, name: '', type: 'default', size: 0, updated: false, stat: false, msg: {value: '', stat: false, msg: ''}},
            location: {value: '', stat: false, msg: '', toggled: false},
            overview: {value: '', stat: false, msg: '', toggled: false},
            start_date: {value: 1, stat: false, msg: '', toggled: false},
            end_date: {value: 1, stat: false, msg: '', toggled: false},
            status: {value: '', stat: false, msg: '', toggled: false},
            user_id: {value: 1, stat: false, msg: '', toggled: false},
            company_id: {value: 1, stat: false, msg: '', toggled: false},
            statupdate: {value: 1, stat: false, msg: '', toggled: false},
            deployment: {value: '', stat: false, msg: '', toggled: false},
            employment: {value: '', stat: false, msg: '', toggled: false},


            // project: {value: '', stat: false, msg: '', toggled: false},
    }})

    
   
     
    return {     
        card: {data: card, set: setCard},  
        listLoader: {data: listLoader, set: setListLoader},
        inftScroll:{data: inftScroll, set: setInftScroll}, 
        lid:{data: lid, set: setLid},
        lSearch: {data: lSearch, set: setLSearch},
        menu: {data: menu, set: setMenu},
        anchorEl: {data: anchorEl, set: setAnchorEl},
        career_id: {data: career_id, set: setCareerId },
        careerStatus:{data: careerStatus, set: setCareerStatus}, 
        btnLoader:{data: btnLoader, set: setBtnLoader},
        saveStatModal:{data: saveStatModal, set: setSaveStatModal },
        stat:{data: stat, set: setStat},
        repostModal:{data: repostModal, set: setRepost},
        id :{data:id ,set: setId },
        form: {data: form, set: setForm},
        openMenu: {data: openMenu, set: setOpenMenu},
        // active: {data: active, set: setActive}

        //Create Update Form
        updateLoader: {data: updateLoader, set: setUpdateLoader},
        employmentStatus:{data: employmentStatus, set: setEmploymentStatus},
        deploymentArrangement:{data: deploymentArrangement, set: setDeploymentArrangement},
        employmentSelected:{data: employmentSelected, set: setEmploymentSelected},
        employmentId :{data:employmentId ,set: setEmploymentId },
        deploymentId :{data:deploymentId ,set: setDeploymentId },
        deploymentSelected: {data: deploymentSelected, set: setDeploymentSelected},
        saveForm:{data: saveForm, set: setSaveForm},
        saveLoader:{data: saveLoader, set: setSaveLoader},
        btnSaveLoader:{data:btnSaveLoader, set: setBtnSaveLoader},
        msg:{data: msg, set: setMsg},
        referralModal: {data: referralModal, set : setReferralModal},

        //Personalization
        prnzlData: {data: prnzlData, set: setPrnzlData},
        prnlzationModal: {data: prnlzationModal, set: setPrnlzationModal},
        cafguModal:{data: cafguModal, set: setCafguModal},
        pznlTour:{data: pznlTour, set: setPznlTour},
        addTour: {data: addTour, set: setAddTour},
        featureTour: {data: featureTour, set: setFeatureTour},
        startHere: {data: startHere, set: setStartHere},
        walkthrough: {data: walkthrough, set: setWalkthrough },
        readCareerPost: {data:readCareerPost, set: setReadCareerPost},

        //View
        pview: {data: pview, set: setPview},
        previewLoader: {data: previewLoader, set: setPreviewLoader},
        posterId: {data: posterId, set: setPosterId},

        //HRC Integ
        hrcId: {data: hrcId, set: setHrcId},
        hrcLoader: {data: hrcLoader, set: setHrcLoader},
        toolTP:{data: toolTP, set: setToolTP},

        //Referral

        refStat: {data: refStat, set: setRefStat},
        refStatModal: {data: refStatModal, set: setRefStatModal},

        // Ubr
        welcome: {data: welcome, set: setWelcome},

        //signUp
        createAccount: {data : createAccount, set: setCreateAccount},

        //IndexDb
        localDb:{data: localDb, setLocalDb, set: setLocalDb},

       
    




    

       
    }
}